// extracted by mini-css-extract-plugin
export var leftAlign = "_2s-2";
export var popper = "_2s-0";
export var subtitle = "_2s-1";